// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.roadmap {
  padding: 4rem 2rem;
  background-color: #0C111B;
  background-image: linear-gradient(to bottom, #131b2c 0%, #0C111B 15%, #0C111B 85%, #131b2c 100%);
  color: white;
  overflow: hidden;
  position: relative;
}

.roadmap::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: radial-gradient(circle at center, rgba(153, 69, 255, 0.03) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 0;
  animation: pulse-bg 10s ease-in-out infinite;
}

.roadmap .section-header {
  position: relative;
  z-index: 1;
}

.roadmap .section-header h2 {
  color: white;
  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);
  background: linear-gradient(to right, #ffffff, #9945FF);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.roadmap .section-header p {
  color: #9BA5B7;
}

.roadmap-container {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  padding: 3rem 0;
  position: relative;
  z-index: 1;
}

/* Section transition elements */
.section-transition-top {
  position: absolute;
  top: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.3), transparent);
  opacity: 0.5;
}

.section-transition-bottom {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.3), transparent);
  opacity: 0.5;
}

.roadmap-step {
  display: flex;
  flex-direction: column;
  align-items: center;
  position: relative;
  flex: 1 1;
  min-width: 150px;
  padding: 0 10px;
}

.step-number {
  width: 50px;
  height: 50px;
  background: linear-gradient(135deg, #131b2c, #0e1520);
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1.5rem;
  font-weight: bold;
  color: white;
  position: relative;
  z-index: 2;
  box-shadow: 0 0 15px rgba(153, 69, 255, 0.5);
  border: 2px solid rgba(153, 69, 255, 0.5);
  transition: all 0.3s ease;
}

.roadmap-step:hover .step-number {
  transform: scale(1.1);
  box-shadow: 0 0 20px rgba(153, 69, 255, 0.7);
}

.step-content {
  text-align: center;
  max-width: 180px;
  transition: transform 0.3s ease;
}

.roadmap-step:hover .step-content {
  transform: translateY(-5px);
}

.step-content h3 {
  margin: 0 0 0.7rem;
  color: #14F195;
  font-size: 1.4rem;
}

.step-content p {
  margin: 0;
  color: #ccc;
  font-size: 0.95rem;
  line-height: 1.4;
}

.step-connector {
  position: absolute;
  top: 25px;
  right: -50%;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, rgba(153, 69, 255, 0.5), rgba(20, 241, 149, 0.3));
  z-index: 1;
}

/* Mobile responsive adjustments */
@media (max-width: 768px) {
  .roadmap {
    padding: 3rem 1rem;
  }
  
  .roadmap-container {
    flex-direction: column;
    padding: 1rem 0;
  }
  
  .roadmap-container:before {
    width: 2px;
    top: 0;
    bottom: 0;
    left: 25px;
    right: auto;
    height: auto;
  }
  
  .roadmap-step {
    flex-direction: row;
    align-items: flex-start;
    margin-bottom: 2rem;
    min-width: auto;
    width: 100%;
    padding: 0;
  }
  
  .step-number {
    width: 50px;
    height: 50px;
    margin-right: 1.5rem;
    margin-bottom: 0;
  }
  
  .step-content {
    text-align: left;
    max-width: none;
    padding-top: 0.5rem;
  }
  
  .roadmap-step:hover .step-content {
    transform: none;
  }
  
  .step-connector {
    position: absolute;
    top: 50px;
    left: 25px;
    width: 2px;
    height: calc(100% + 1rem);
  }
}

/* Add transition dots between sections */
.roadmap::after {
  content: '•••';
  position: absolute;
  bottom: -20px;
  left: 50%;
  transform: translateX(-50%);
  color: rgba(153, 69, 255, 0.5);
  font-size: 1.5rem;
  letter-spacing: 0.5rem;
}

.course-modules {
  padding: 4rem 2rem;
  background-color: #0C111B;
  background-image: linear-gradient(to bottom, #131b2c 0%, #0C111B 15%, #0C111B 85%, #131b2c 100%);
  position: relative;
  overflow: hidden;
  margin-top: -1px; /* Eliminate any gap between sections */
}

.course-modules::before {
  content: '';
  position: absolute;
  top: -50%;
  left: -50%;
  right: -50%;
  bottom: -50%;
  background: radial-gradient(circle at center, rgba(20, 241, 149, 0.03) 0%, rgba(0, 0, 0, 0) 70%);
  z-index: 0;
  animation: pulse-bg 10s ease-in-out infinite alternate;
}

.course-modules .section-header h2 {
  color: white;
  text-shadow: 0 0 20px rgba(20, 241, 149, 0.3);
  background: linear-gradient(to right, #ffffff, #14F195);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.course-modules .section-header p {
  color: #9BA5B7;
}

.modules-container {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(2, auto);
  gap: 2rem;
  max-width: 1200px;
  margin: 0 auto;
  position: relative;
  z-index: 1;
}

.module-card {
  background: linear-gradient(145deg, #131b2c, #0e1520);
  border-radius: 12px;
  padding: 1.5rem;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  border: 1px solid rgba(255, 255, 255, 0.05);
  position: relative;
}

.module-card::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 3px;
  background: linear-gradient(90deg, #9945FF, #14F195);
  opacity: 0;
  transition: opacity 0.3s ease;
}

.module-card:hover {
  transform: translateY(-10px);
  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(20, 241, 149, 0.2);
}

.module-card:hover::before {
  opacity: 1;
}

.module-card h3 {
  color: white;
  margin-bottom: 1.5rem;
  font-size: 1.3rem;
  background: linear-gradient(to right, #ffffff, #14F195);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  position: relative;
}

.topics-two-columns {
  display: flex;
  justify-content: space-between;
  width: 100%;
}

.topics-column {
  width: 48%;
  padding-left: 20px;
  margin: 0;
}

.module-card ul {
  margin: 0;
  padding-left: 1.5rem;
}

.module-card li {
  margin-bottom: 0.8rem;
  color: #9BA5B7;
  position: relative;
}

.module-card li::before {
  content: "";
  position: absolute;
  left: -1.2rem;
  top: 0.5rem;
  width: 6px;
  height: 6px;
  background-color: #9945FF;
  border-radius: 50%;
  box-shadow: 0 0 6px rgba(153, 69, 255, 0.6);
}

/* Section transition elements */
.course-modules .section-transition-top {
  position: absolute;
  top: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.3), transparent);
  opacity: 0.5;
}

.course-modules .section-transition-bottom {
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 100%;
  height: 4px;
  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.3), transparent);
  opacity: 0.5;
}

@media (max-width: 768px) {
  .course-modules {
    padding: 3rem 1rem;
  }
  
  .modules-container {
    grid-template-columns: 1fr;
    grid-template-rows: repeat(4, auto);
  }
}

/* Styling for topic items with subtopics */
.has-subtopics {
  cursor: pointer;
}

.topic-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  transition: color 0.2s ease;
}

.has-subtopics .topic-title:hover {
  color: #14F195;
}

.expand-icon {
  display: inline-block;
  width: 20px;
  height: 20px;
  text-align: center;
  line-height: 20px;
  border-radius: 50%;
  background-color: rgba(153, 69, 255, 0.2);
  color: #fff;
  margin-left: 8px;
  font-size: 14px;
  transition: all 0.3s ease;
}

.expand-icon.expanded {
  background-color: rgba(20, 241, 149, 0.2);
  transform: rotate(180deg);
}

.subtopics-list {
  margin-top: 10px;
  margin-bottom: 10px;
  padding-left: 20px;
  border-left: 1px dashed rgba(153, 69, 255, 0.3);
  animation: fadeIn 0.3s ease-in-out;
}

.subtopics-list li {
  font-size: 0.9rem;
  margin-bottom: 6px;
  color: #9BA5B7;
}

.subtopics-list li::before {
  background-color: #14F195;
  width: 4px;
  height: 4px;
}

@keyframes fadeIn {
  from { opacity: 0; transform: translateY(-10px); }
  to { opacity: 1; transform: translateY(0); }
}

/* Mobile responsiveness for subtopics */
@media (max-width: 768px) {
  .topics-two-columns {
    flex-direction: column;
  }
  
  .topics-column {
    width: 100%;
    margin-bottom: 20px;
  }
  
  .topics-column:last-child {
    margin-bottom: 0;
  }
}

/* Mindmap Section Styles */
.mindmap-section {
  margin: 4rem 0;
  position: relative;
  z-index: 1;
}

.mindmap-section .section-header {
  margin-bottom: 2rem;
}

.mindmap-section .section-header h3 {
  color: #14F195;
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 0.5rem;
  text-shadow: 0 0 15px rgba(20, 241, 149, 0.3);
}

.mindmap-section .section-header p {
  color: #9BA5B7;
  font-size: 1.1rem;
  max-width: 600px;
  margin: 0 auto;
}

.mindmap-container {
  max-width: 1200px;
  margin: 0 auto;
  background: linear-gradient(135deg, rgba(19, 27, 44, 0.8), rgba(14, 21, 32, 0.9));
  border-radius: 16px;
  padding: 2rem;
  box-shadow: 
    0 10px 30px rgba(0, 0, 0, 0.3),
    0 0 0 1px rgba(153, 69, 255, 0.1);
  position: relative;
  overflow: hidden;
}

.mindmap-container::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: radial-gradient(circle at 30% 70%, rgba(153, 69, 255, 0.1) 0%, transparent 50%),
              radial-gradient(circle at 70% 30%, rgba(20, 241, 149, 0.05) 0%, transparent 50%);
  pointer-events: none;
  z-index: 0;
}

.mindmap-iframe {
  width: 100%;
  height: 600px;
  border: none;
  border-radius: 12px;
  background: white;
  position: relative;
  z-index: 1;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);
  transition: all 0.3s ease;
}

.mindmap-iframe:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);
}

/* Loading state for iframe */
.mindmap-container::after {
  content: '🧠 Loading Interactive Mindmap...';
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: #9BA5B7;
  font-size: 1.1rem;
  z-index: 0;
  opacity: 0.7;
  pointer-events: none;
}

/* Responsive Design for Mindmap */
@media (max-width: 768px) {
  .mindmap-section {
    margin: 2rem 0;
  }
  
  .mindmap-container {
    margin: 0 1rem;
    padding: 1rem;
    border-radius: 12px;
  }
  
  .mindmap-iframe {
    height: 400px;
    border-radius: 8px;
  }
  
  .mindmap-section .section-header h3 {
    font-size: 1.5rem;
  }
  
  .mindmap-section .section-header p {
    font-size: 1rem;
    padding: 0 1rem;
  }
}

@media (max-width: 480px) {
  .mindmap-iframe {
    height: 350px;
  }
  
  .mindmap-container {
    padding: 0.75rem;
  }
}

/* Animation for mindmap container */
@keyframes mindmap-fade-in {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.mindmap-container {
  animation: mindmap-fade-in 0.8s ease-out;
} `, "",{"version":3,"sources":["webpack://./src/components/CourseOutline.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gGAAgG;EAChG,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gGAAgG;EAChG,UAAU;EACV,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,eAAe;EACf,kBAAkB;EAClB,UAAU;AACZ;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,kBAAkB;EAClB,UAAU;EACV,4CAA4C;EAC5C,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;AACjC;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,SAAS;EACT,WAAW;EACX,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,WAAW;EACX,uFAAuF;EACvF,UAAU;AACZ;;AAEA,kCAAkC;AAClC;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,sBAAsB;IACtB,eAAe;EACjB;;EAEA;IACE,UAAU;IACV,MAAM;IACN,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,uBAAuB;IACvB,mBAAmB;IACnB,eAAe;IACf,WAAW;IACX,UAAU;EACZ;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,oBAAoB;IACpB,gBAAgB;EAClB;;EAEA;IACE,gBAAgB;IAChB,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,UAAU;IACV,yBAAyB;EAC3B;AACF;;AAEA,yCAAyC;AACzC;EACE,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,SAAS;EACT,2BAA2B;EAC3B,8BAA8B;EAC9B,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,yBAAyB;EACzB,gGAAgG;EAChG,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB,EAAE,uCAAuC;AAC3D;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,SAAS;EACT,UAAU;EACV,WAAW;EACX,YAAY;EACZ,gGAAgG;EAChG,UAAU;EACV,sDAAsD;AACxD;;AAEA;EACE,YAAY;EACZ,6CAA6C;EAC7C,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,mCAAmC;EACnC,SAAS;EACT,iBAAiB;EACjB,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,qDAAqD;EACrD,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,qDAAqD;EACrD,2CAA2C;EAC3C,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,WAAW;EACX,WAAW;EACX,oDAAoD;EACpD,UAAU;EACV,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;EAC5B,4EAA4E;AAC9E;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,iBAAiB;EACjB,uDAAuD;EACvD,6BAA6B;EAC7B,oCAAoC;EACpC,qBAAqB;EACrB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,UAAU;EACV,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,UAAU;EACV,WAAW;EACX,yBAAyB;EACzB,kBAAkB;EAClB,2CAA2C;AAC7C;;AAEA,gCAAgC;AAChC;EACE,kBAAkB;EAClB,SAAS;EACT,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,qFAAqF;EACrF,YAAY;AACd;;AAEA;EACE;IACE,kBAAkB;EACpB;;EAEA;IACE,0BAA0B;IAC1B,mCAAmC;EACrC;AACF;;AAEA,2CAA2C;AAC3C;EACE,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yCAAyC;EACzC,WAAW;EACX,gBAAgB;EAChB,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+CAA+C;EAC/C,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,UAAU;EACV,WAAW;AACb;;AAEA;EACE,OAAO,UAAU,EAAE,4BAA4B,EAAE;EACjD,KAAK,UAAU,EAAE,wBAAwB,EAAE;AAC7C;;AAEA,wCAAwC;AACxC;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,mBAAmB;EACrB;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,2BAA2B;AAC3B;EACE,cAAc;EACd,kBAAkB;EAClB,UAAU;AACZ;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,6CAA6C;AAC/C;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,cAAc;EACd,iFAAiF;EACjF,mBAAmB;EACnB,aAAa;EACb;;qCAEmC;EACnC,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT;8FAC4F;EAC5F,oBAAoB;EACpB,UAAU;AACZ;;AAEA;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,iBAAiB;EACjB,kBAAkB;EAClB,UAAU;EACV,yCAAyC;EACzC,yBAAyB;AAC3B;;AAEA;EACE,2BAA2B;EAC3B,yCAAyC;AAC3C;;AAEA,6BAA6B;AAC7B;EACE,4CAA4C;EAC5C,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,gCAAgC;EAChC,cAAc;EACd,iBAAiB;EACjB,UAAU;EACV,YAAY;EACZ,oBAAoB;AACtB;;AAEA,kCAAkC;AAClC;EACE;IACE,cAAc;EAChB;;EAEA;IACE,cAAc;IACd,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,aAAa;IACb,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,eAAe;EACjB;AACF;;AAEA;EACE;IACE,aAAa;EACf;;EAEA;IACE,gBAAgB;EAClB;AACF;;AAEA,oCAAoC;AACpC;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA;EACE,wCAAwC;AAC1C","sourcesContent":[".roadmap {\n  padding: 4rem 2rem;\n  background-color: #0C111B;\n  background-image: linear-gradient(to bottom, #131b2c 0%, #0C111B 15%, #0C111B 85%, #131b2c 100%);\n  color: white;\n  overflow: hidden;\n  position: relative;\n}\n\n.roadmap::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  right: -50%;\n  bottom: -50%;\n  background: radial-gradient(circle at center, rgba(153, 69, 255, 0.03) 0%, rgba(0, 0, 0, 0) 70%);\n  z-index: 0;\n  animation: pulse-bg 10s ease-in-out infinite;\n}\n\n.roadmap .section-header {\n  position: relative;\n  z-index: 1;\n}\n\n.roadmap .section-header h2 {\n  color: white;\n  text-shadow: 0 0 20px rgba(153, 69, 255, 0.3);\n  background: linear-gradient(to right, #ffffff, #9945FF);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.roadmap .section-header p {\n  color: #9BA5B7;\n}\n\n.roadmap-container {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 3rem 0;\n  position: relative;\n  z-index: 1;\n}\n\n/* Section transition elements */\n.section-transition-top {\n  position: absolute;\n  top: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.3), transparent);\n  opacity: 0.5;\n}\n\n.section-transition-bottom {\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.3), transparent);\n  opacity: 0.5;\n}\n\n.roadmap-step {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  position: relative;\n  flex: 1;\n  min-width: 150px;\n  padding: 0 10px;\n}\n\n.step-number {\n  width: 50px;\n  height: 50px;\n  background: linear-gradient(135deg, #131b2c, #0e1520);\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.5rem;\n  font-weight: bold;\n  color: white;\n  position: relative;\n  z-index: 2;\n  box-shadow: 0 0 15px rgba(153, 69, 255, 0.5);\n  border: 2px solid rgba(153, 69, 255, 0.5);\n  transition: all 0.3s ease;\n}\n\n.roadmap-step:hover .step-number {\n  transform: scale(1.1);\n  box-shadow: 0 0 20px rgba(153, 69, 255, 0.7);\n}\n\n.step-content {\n  text-align: center;\n  max-width: 180px;\n  transition: transform 0.3s ease;\n}\n\n.roadmap-step:hover .step-content {\n  transform: translateY(-5px);\n}\n\n.step-content h3 {\n  margin: 0 0 0.7rem;\n  color: #14F195;\n  font-size: 1.4rem;\n}\n\n.step-content p {\n  margin: 0;\n  color: #ccc;\n  font-size: 0.95rem;\n  line-height: 1.4;\n}\n\n.step-connector {\n  position: absolute;\n  top: 25px;\n  right: -50%;\n  width: 100%;\n  height: 2px;\n  background: linear-gradient(to right, rgba(153, 69, 255, 0.5), rgba(20, 241, 149, 0.3));\n  z-index: 1;\n}\n\n/* Mobile responsive adjustments */\n@media (max-width: 768px) {\n  .roadmap {\n    padding: 3rem 1rem;\n  }\n  \n  .roadmap-container {\n    flex-direction: column;\n    padding: 1rem 0;\n  }\n  \n  .roadmap-container:before {\n    width: 2px;\n    top: 0;\n    bottom: 0;\n    left: 25px;\n    right: auto;\n    height: auto;\n  }\n  \n  .roadmap-step {\n    flex-direction: row;\n    align-items: flex-start;\n    margin-bottom: 2rem;\n    min-width: auto;\n    width: 100%;\n    padding: 0;\n  }\n  \n  .step-number {\n    width: 50px;\n    height: 50px;\n    margin-right: 1.5rem;\n    margin-bottom: 0;\n  }\n  \n  .step-content {\n    text-align: left;\n    max-width: none;\n    padding-top: 0.5rem;\n  }\n  \n  .roadmap-step:hover .step-content {\n    transform: none;\n  }\n  \n  .step-connector {\n    position: absolute;\n    top: 50px;\n    left: 25px;\n    width: 2px;\n    height: calc(100% + 1rem);\n  }\n}\n\n/* Add transition dots between sections */\n.roadmap::after {\n  content: '•••';\n  position: absolute;\n  bottom: -20px;\n  left: 50%;\n  transform: translateX(-50%);\n  color: rgba(153, 69, 255, 0.5);\n  font-size: 1.5rem;\n  letter-spacing: 0.5rem;\n}\n\n.course-modules {\n  padding: 4rem 2rem;\n  background-color: #0C111B;\n  background-image: linear-gradient(to bottom, #131b2c 0%, #0C111B 15%, #0C111B 85%, #131b2c 100%);\n  position: relative;\n  overflow: hidden;\n  margin-top: -1px; /* Eliminate any gap between sections */\n}\n\n.course-modules::before {\n  content: '';\n  position: absolute;\n  top: -50%;\n  left: -50%;\n  right: -50%;\n  bottom: -50%;\n  background: radial-gradient(circle at center, rgba(20, 241, 149, 0.03) 0%, rgba(0, 0, 0, 0) 70%);\n  z-index: 0;\n  animation: pulse-bg 10s ease-in-out infinite alternate;\n}\n\n.course-modules .section-header h2 {\n  color: white;\n  text-shadow: 0 0 20px rgba(20, 241, 149, 0.3);\n  background: linear-gradient(to right, #ffffff, #14F195);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n}\n\n.course-modules .section-header p {\n  color: #9BA5B7;\n}\n\n.modules-container {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  grid-template-rows: repeat(2, auto);\n  gap: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n  position: relative;\n  z-index: 1;\n}\n\n.module-card {\n  background: linear-gradient(145deg, #131b2c, #0e1520);\n  border-radius: 12px;\n  padding: 1.5rem;\n  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.3);\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\n  border: 1px solid rgba(255, 255, 255, 0.05);\n  position: relative;\n}\n\n.module-card::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 3px;\n  background: linear-gradient(90deg, #9945FF, #14F195);\n  opacity: 0;\n  transition: opacity 0.3s ease;\n}\n\n.module-card:hover {\n  transform: translateY(-10px);\n  box-shadow: 0 15px 35px rgba(0, 0, 0, 0.4), 0 0 20px rgba(20, 241, 149, 0.2);\n}\n\n.module-card:hover::before {\n  opacity: 1;\n}\n\n.module-card h3 {\n  color: white;\n  margin-bottom: 1.5rem;\n  font-size: 1.3rem;\n  background: linear-gradient(to right, #ffffff, #14F195);\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n  background-clip: text;\n  position: relative;\n}\n\n.topics-two-columns {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n}\n\n.topics-column {\n  width: 48%;\n  padding-left: 20px;\n  margin: 0;\n}\n\n.module-card ul {\n  margin: 0;\n  padding-left: 1.5rem;\n}\n\n.module-card li {\n  margin-bottom: 0.8rem;\n  color: #9BA5B7;\n  position: relative;\n}\n\n.module-card li::before {\n  content: \"\";\n  position: absolute;\n  left: -1.2rem;\n  top: 0.5rem;\n  width: 6px;\n  height: 6px;\n  background-color: #9945FF;\n  border-radius: 50%;\n  box-shadow: 0 0 6px rgba(153, 69, 255, 0.6);\n}\n\n/* Section transition elements */\n.course-modules .section-transition-top {\n  position: absolute;\n  top: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.3), transparent);\n  opacity: 0.5;\n}\n\n.course-modules .section-transition-bottom {\n  position: absolute;\n  bottom: -2px;\n  left: 0;\n  width: 100%;\n  height: 4px;\n  background: linear-gradient(90deg, transparent, rgba(20, 241, 149, 0.3), transparent);\n  opacity: 0.5;\n}\n\n@media (max-width: 768px) {\n  .course-modules {\n    padding: 3rem 1rem;\n  }\n  \n  .modules-container {\n    grid-template-columns: 1fr;\n    grid-template-rows: repeat(4, auto);\n  }\n}\n\n/* Styling for topic items with subtopics */\n.has-subtopics {\n  cursor: pointer;\n}\n\n.topic-title {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  transition: color 0.2s ease;\n}\n\n.has-subtopics .topic-title:hover {\n  color: #14F195;\n}\n\n.expand-icon {\n  display: inline-block;\n  width: 20px;\n  height: 20px;\n  text-align: center;\n  line-height: 20px;\n  border-radius: 50%;\n  background-color: rgba(153, 69, 255, 0.2);\n  color: #fff;\n  margin-left: 8px;\n  font-size: 14px;\n  transition: all 0.3s ease;\n}\n\n.expand-icon.expanded {\n  background-color: rgba(20, 241, 149, 0.2);\n  transform: rotate(180deg);\n}\n\n.subtopics-list {\n  margin-top: 10px;\n  margin-bottom: 10px;\n  padding-left: 20px;\n  border-left: 1px dashed rgba(153, 69, 255, 0.3);\n  animation: fadeIn 0.3s ease-in-out;\n}\n\n.subtopics-list li {\n  font-size: 0.9rem;\n  margin-bottom: 6px;\n  color: #9BA5B7;\n}\n\n.subtopics-list li::before {\n  background-color: #14F195;\n  width: 4px;\n  height: 4px;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; transform: translateY(-10px); }\n  to { opacity: 1; transform: translateY(0); }\n}\n\n/* Mobile responsiveness for subtopics */\n@media (max-width: 768px) {\n  .topics-two-columns {\n    flex-direction: column;\n  }\n  \n  .topics-column {\n    width: 100%;\n    margin-bottom: 20px;\n  }\n  \n  .topics-column:last-child {\n    margin-bottom: 0;\n  }\n}\n\n/* Mindmap Section Styles */\n.mindmap-section {\n  margin: 4rem 0;\n  position: relative;\n  z-index: 1;\n}\n\n.mindmap-section .section-header {\n  margin-bottom: 2rem;\n}\n\n.mindmap-section .section-header h3 {\n  color: #14F195;\n  font-size: 2rem;\n  font-weight: 600;\n  margin-bottom: 0.5rem;\n  text-shadow: 0 0 15px rgba(20, 241, 149, 0.3);\n}\n\n.mindmap-section .section-header p {\n  color: #9BA5B7;\n  font-size: 1.1rem;\n  max-width: 600px;\n  margin: 0 auto;\n}\n\n.mindmap-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  background: linear-gradient(135deg, rgba(19, 27, 44, 0.8), rgba(14, 21, 32, 0.9));\n  border-radius: 16px;\n  padding: 2rem;\n  box-shadow: \n    0 10px 30px rgba(0, 0, 0, 0.3),\n    0 0 0 1px rgba(153, 69, 255, 0.1);\n  position: relative;\n  overflow: hidden;\n}\n\n.mindmap-container::before {\n  content: '';\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: radial-gradient(circle at 30% 70%, rgba(153, 69, 255, 0.1) 0%, transparent 50%),\n              radial-gradient(circle at 70% 30%, rgba(20, 241, 149, 0.05) 0%, transparent 50%);\n  pointer-events: none;\n  z-index: 0;\n}\n\n.mindmap-iframe {\n  width: 100%;\n  height: 600px;\n  border: none;\n  border-radius: 12px;\n  background: white;\n  position: relative;\n  z-index: 1;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.2);\n  transition: all 0.3s ease;\n}\n\n.mindmap-iframe:hover {\n  transform: translateY(-2px);\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.3);\n}\n\n/* Loading state for iframe */\n.mindmap-container::after {\n  content: '🧠 Loading Interactive Mindmap...';\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  color: #9BA5B7;\n  font-size: 1.1rem;\n  z-index: 0;\n  opacity: 0.7;\n  pointer-events: none;\n}\n\n/* Responsive Design for Mindmap */\n@media (max-width: 768px) {\n  .mindmap-section {\n    margin: 2rem 0;\n  }\n  \n  .mindmap-container {\n    margin: 0 1rem;\n    padding: 1rem;\n    border-radius: 12px;\n  }\n  \n  .mindmap-iframe {\n    height: 400px;\n    border-radius: 8px;\n  }\n  \n  .mindmap-section .section-header h3 {\n    font-size: 1.5rem;\n  }\n  \n  .mindmap-section .section-header p {\n    font-size: 1rem;\n    padding: 0 1rem;\n  }\n}\n\n@media (max-width: 480px) {\n  .mindmap-iframe {\n    height: 350px;\n  }\n  \n  .mindmap-container {\n    padding: 0.75rem;\n  }\n}\n\n/* Animation for mindmap container */\n@keyframes mindmap-fade-in {\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n.mindmap-container {\n  animation: mindmap-fade-in 0.8s ease-out;\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
